import { Typography } from '@material-ui/core';
import React, { FC, ReactNode } from 'react';

interface SubheadingProps {
  children: ReactNode;
}

const Subheading: FC<SubheadingProps> = ({ children }) => (
  <Typography variant="body1" style={{ padding: '8px 0', whiteSpace: 'pre-line' }}>
    {children}
  </Typography>
);

export default Subheading;
